import styled from "styled-components";

const HomeSlogan = styled.h1`
text-align: center;
color: #000;
font-weight: 600;
font-size: 150px;
font-family: sans-serif;
margin-top: 32px;
line-height: 0;
`

export default HomeSlogan
